import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { SocialPublishAtField } from '@app/modules/social-export/components/inputs/SocialPublishAtField';
import { TextFieldElementWithEmoji } from '@app/modules/social-export/components/inputs/TextFieldElementWithEmoji';
import { PublishFormUnsavedChangesWarning } from '@app/modules/social-export/components/PublishFormUnsavedChangesWarning';
import { BaseExportFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { zodResolver } from '@hookform/resolvers/zod';
import { Stack } from '@mui/material';
import { FormContainer } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { DemoSettingsDto } from '../../social-export.types';
import { DemoPublishValues, useDemoPublishSchema } from './useDemoPublishSchema';

type DemoPublishFormProps = BaseExportFormProps<DemoPublishValues, DemoSettingsDto>;

export function DemoPublishForm({ source, onUpload, actions }: DemoPublishFormProps) {
  const { $t } = useIntl();
  const schema = useDemoPublishSchema();
  const initialValues: DemoPublishValues = {
    title: source.title ?? '',
    description: source.description ?? '',
    publishAt: null,
  };

  return (
    <FormContainer
      values={initialValues}
      mode="onBlur"
      resolver={zodResolver(schema)}
      onSuccess={async (formData) => {
        await onUpload(formData);
      }}
    >
      <PublishFormUnsavedChangesWarning />
      <ContentCluster
        title={$t({
          id: 'socialExport.form.demoData',
          defaultMessage: 'Datos de demo',
        })}
      >
        <Stack spacing={3}>
          <TextFieldElementWithEmoji
            name="title"
            label={$t({
              id: 'socialExport.form.title',
              defaultMessage: 'Título',
            })}
            required
            fullWidth
          />
          <TextFieldElementWithEmoji
            name="description"
            label={$t({
              id: 'socialExport.form.description',
              defaultMessage: 'Descripción',
            })}
            required
            fullWidth
            multiline
            rows={3}
          />
        </Stack>
      </ContentCluster>
      <ContentCluster
        title={$t({
          id: 'socialExport.form.schedule',
          defaultMessage: 'Programación',
        })}
      >
        <SocialPublishAtField />
      </ContentCluster>
      {actions}
    </FormContainer>
  );
}
